import { CustomerAppType } from '../customer/app';
import { Duration } from '../duration';
import { OtherString } from '../otherString';
import { ParsedBoolean } from '../parsed/parsedBoolean';
import { z } from 'zod';

export const SupportLocation = z.object({
    coordinates: z.string().nullish(),
    geofenceDistance: z.number().nullish(),
});

export const StoreGeneralConfig = z.object({
    isRwwsStore: z.string().nullish(),
    storeInventoryManagementSystem: z.string().nullish(),
    storeMapFancyFile: z.string().nullish(),
    storeMapFancyBounds: z.string().nullish(),
    storeMapFile: z.string().nullish(),
    storeMapBounds: z.string().nullish(),
    featureNewStoreLayout: z.string().nullish(),
    featureSessionSurveillanceEnabled: z.string().nullish(),
    useNewDebitCreditImagesAtCheckout: z.string().nullish(),
    offlinePaymentsHideButton: z.string().nullish(),
    branding: z.string().nullish(),
    enableEdekaApp: ParsedBoolean.nullish(),
    enableManualRandomCheck: z.string().nullish(),
    enableMissingCartsReporting: z.boolean().nullish(),
    enableShowGpsCartsLocationsTab: ParsedBoolean.nullish(),
    dsiClassificationDetectionThreshold: z.string().nullish(),
    promotionTemplateURL: z.string().nullish(),
    productImportTempalteURL: z.string().nullish(),
    duplicatePaymentCheck: ParsedBoolean.nullish(),
    enableCustomerMark: ParsedBoolean.nullish(),
    uiDisplayCurrency: z.string().nullish(),
    enablePluHierarchy: ParsedBoolean.nullish(),
    hasCashierCheckout: ParsedBoolean.nullish(),
    expressShopping: ParsedBoolean.nullish(),
    hasSelfCheckout: ParsedBoolean.nullish(),
    showDeferredPayments: ParsedBoolean.nullish(),
    showPromotionDescription: ParsedBoolean.nullish(),
    showPromotionDisclaimer: ParsedBoolean.nullish(),
    paymentNotifyOnDeferredPaymentVerification: ParsedBoolean.nullish(),
    enableSkipFailedRandomCheck: ParsedBoolean.nullish(),
    enablePaymentSosGeneralHelp: ParsedBoolean.nullish(),
    fallbackLanguage: z.string().nullish(),
    kddrDefaultCoupons: z.string().nullish(),
    newProductAge: Duration.or(z.literal('')).nullish(),
    newProductShowFilter: z.boolean().nullish(),
    activatedCustomerAppPaymentMethods: CustomerAppType.or(OtherString).nullish(),
    brandEditorMaxCustomIcons: z.int().nullish(),
    marketingSlideshowMaxFiles: z.int().nullish(),
    marketingMaxPromotedProducts: z.int().nullish(),
    marketingMaxSlotsPerType: z.int().nullish(),
    marketingUpliftBaselineDaysDefault: z.int().nullish(),
    marketingUpliftBaselineDaysMin: z.int().nullish(),
    marketingUpliftBaselineDaysMax: z.int().nullish(),
    enableCustomerMarkReasonInCheckout: z.boolean().nullish(),
    enableSensorFusionSnapshotsZoomableInCheckout: z.boolean().nullish(),
    // GPS related configurations
    gpsStoreCoordinates: z.string().nullish(),
    gpsStoreGeofenceDistance: z.number().nullish(),
    gpsSupportLocations: z.array(SupportLocation.nullish()).nullish(),
});

export type SupportLocation = z.infer<typeof SupportLocation>;
export type StoreGeneralConfig = z.infer<typeof StoreGeneralConfig>;
